import { PartnerType } from "@/app/utils/partners.enum";

export const getPartnerImage = (partner: PartnerType): string => {
  const imageMap: Record<PartnerType, string> = {
    [PartnerType.FGTS]: "/fgts.png",
    [PartnerType.CREFAZ]: "/crefaz.png",
    [PartnerType.SALVCAR]: "/salvcar.png",
    [PartnerType.CREFISA]: "/crefisa.png",
    [PartnerType.PAN]: "/pan.png",
    [PartnerType.CLT]: "/clt.svg",
  };

  return imageMap[partner];
};

export const getPartnerBgColor = (partner: PartnerType): string => {
  const bgColorMap: Record<PartnerType, string> = {
    [PartnerType.FGTS]: "#036039",
    [PartnerType.CREFAZ]: "#F77325",
    [PartnerType.SALVCAR]: "#AA63FF",
    [PartnerType.CREFISA]: "#02BCE8",
    [PartnerType.PAN]: "#414141",
    [PartnerType.CLT]: "#4AFFC5",
  };

  return bgColorMap[partner];
};

export const getPartnerCardStyle = (
  partner: PartnerType | string,
): { bg: string; text: string; border: string } => {
  const styleMap: Record<string, { bg: string; text: string; border: string }> =
    {
      [PartnerType.FGTS]: { bg: "#036039", text: "#ffffff", border: "#024a2c" },
      [PartnerType.CREFAZ]: {
        bg: "#F77325",
        text: "#ffffff",
        border: "#d5611e",
      },
      [PartnerType.SALVCAR]: {
        bg: "#AA63FF",
        text: "#ffffff",
        border: "#9450e0",
      },
      [PartnerType.CREFISA]: {
        bg: "#02BCE8",
        text: "#ffffff",
        border: "#02a3ca",
      },
      [PartnerType.PAN]: { bg: "#414141", text: "#ffffff", border: "#2e2e2e" },
      [PartnerType.CLT]: { bg: "#4AFFC5", text: "#ffffff", border: "#4AFFC5" },
    };

  return (
    styleMap[partner] || { bg: "#f3f4f6", text: "#374151", border: "#d1d5db" }
  );
};
